import { Button, Stack, Text, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { ArrayTranslation, Trans, useTranslation } from '@hotjar/translations';
import incidentIllustration from '../../resources/images/incident.svg';

const S = {
  Container: styled.div`
    max-width: 542px;
    height: 100vh;
    margin: 0 auto;
  `,
  InnerContainer: styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: ${tokens.spacer.x1};
    justify-content: center;
  `,
  Image: styled.img`
    width: 100px;
    margin-bottom: ${tokens.spacer.x5};
  `,
  ButtonRow: styled(Stack)`
    margin-top: ${tokens.spacer.x5};
    max-width: fit-content;
  `,
  Title: styled(Text)`
    white-space: unset;
    margin-bottom: ${tokens.spacer.x1};
  `,
};

interface Props {
  withBackButton?: boolean;
}

export const IncidentAlert = ({ withBackButton = false }: Props): JSX.Element => {
  const { t } = useTranslation('checkout', { keyPrefix: `incident` });

  return (
    <S.Container>
      <S.InnerContainer>
        <S.Image src={incidentIllustration} alt="" />

        <S.Title as="h1" textType="header4">
          {t('title')}
        </S.Title>
        <ArrayTranslation
          i18nKey="description"
          t={t}
          mapperFunction={(_, i) => (
            <Text>
              <Trans components={[<strong />]} t={t} i18nKey={`description.${i}`} />
            </Text>
          )}
        />
        <S.ButtonRow direction="row">
          <Button kind="secondary" as="a" href={t('status-link')}>
            {t('view-status')}
          </Button>
          {withBackButton && (
            <Button as="a" href="/">
              {t('back-to-hotjar')}
            </Button>
          )}
        </S.ButtonRow>
      </S.InnerContainer>
    </S.Container>
  );
};
